module.exports = __webpack_public_path__ + "static/media/eq.a4cb9afe.jpeg";